// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.test-results-wrapper {
  width: 100%;
  overflow-x: auto;
  border-top: 1px solid #d7dce2;
}

.test-results-scroll {
  width: max-content;
  min-width: max-content;
}

.test-results-table {
  border-collapse: collapse;
  font-size: 0.86rem;
  width: max-content;
  min-width: max-content;
  table-layout: fixed;
}
.test-results-table th,
.test-results-table td {
  border: 1px solid #dfe3e8;
  padding: 0;
  vertical-align: top;
}
.test-results-table th {
  background-color: #f6f8fb;
  color: #274a67;
  font-weight: 700;
  text-align: center;
  white-space: nowrap;
  padding: 6px 10px;
}

.caption-col {
  width: 720px;
  min-width: 720px;
  max-width: 720px;
  position: sticky;
  left: 0;
  background: #fff;
  z-index: 2;
}

.test-results-table.is-cutback .caption-col {
  width: 600px;
  min-width: 600px;
  max-width: 600px;
}

.test-results-table.has-baseline .caption-col {
  width: 600px;
  min-width: 600px;
  max-width: 600px;
}

.test-results-table.is-cutback.has-baseline .caption-col {
  width: 480px;
  min-width: 480px;
  max-width: 480px;
}

.baseline-col {
  width: 120px;
  min-width: 120px;
  max-width: 120px;
}

.design-col {
  width: 140px;
  min-width: 140px;
  max-width: 140px;
}

th.design-col.wrap-header {
  white-space: normal;
  line-height: 1.2;
}

.group-row td {
  border-left: 0;
  border-right: 0;
}

.group-heading {
  background: #0067b8;
  color: #fff;
  font-weight: 700;
  letter-spacing: 0.01em;
  padding: 7px 12px;
  text-transform: uppercase;
}

.test-row:nth-child(even) .caption-col,
.test-row:nth-child(even) .baseline-col,
.test-row:nth-child(even) .design-col {
  background: #fcfcfd;
}

.test-row .design-col {
  vertical-align: bottom;
}

.test-name {
  border-bottom: 1px solid #e2e6eb;
  color: #1e2f3d;
  font-size: 0.98rem;
  font-weight: 700;
  padding: 8px 12px 7px;
}

.test-cell-stack {
  display: flex;
  flex-direction: column;
  min-width: 0;
  vertical-align: bottom;
}

.labels,
.values {
  padding: 2px 0;
}

.field-entry {
  box-sizing: border-box;
  display: block;
  max-width: 100%;
  min-width: 0;
  line-height: 1.35;
  min-height: 28px;
  overflow: hidden;
  padding: 4px 12px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.labels .field-entry {
  color: #243746;
}

.values .field-entry {
  text-align: center;
  overflow-wrap: botto;
}

.values .section-title {
  color: #1e2f3d;
  font-weight: 600;
  overflow: hidden;
  text-align: center;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.field-value {
  color: #1e2f3d;
  font-weight: 600;
}

.section-title {
  border-top: 1px solid #e7ebf0;
  color: #1f2f3a;
  font-weight: 700;
  height: 34px;
  padding: 8px 12px 4px;
}

.test-cell-stack > .section-title:first-child {
  border-top: 0;
}

.cell-meta {
  border-top: 1px solid #eef1f5;
  color: #52697d;
  font-size: 0.75rem;
  padding: 6px 12px 8px;
  text-align: right;
}

.cell-meta-top {
  border-top: 0;
  border-bottom: 1px solid #eef1f5;
  color: #1f2f3a;
  font-size: 0.8rem;
  padding: 6px 8px 5px;
}

.rheology-values-grid {
  align-items: center;
  display: grid;
  gap: 0 2px;
  padding: 2px 0;
}

.rheology-value-head,
.rheology-value-cell {
  border-bottom: 1px solid #eef1f5;
  min-height: 28px;
  padding: 4px 2px;
  text-align: center;
}

.rheology-value-head {
  align-items: center;
  color: #3a5368;
  display: flex;
  font-size: 0.68rem;
  font-weight: 700;
  justify-content: center;
  min-height: 34px;
}

.rheology-value-cell {
  color: #1e2f3d;
  font-size: 0.78rem;
  font-weight: 400;
}

.rheology-value-cell.is-bold {
  font-weight: 700;
}

.es-matrix {
  display: grid;
  gap: 8px;
  padding: 8px 10px;
}

.es-matrix.compact {
  align-items: center;
  display: grid;
  gap: 0 2px;
  height: 100%;
  padding: 2px 0;
}

.es-reading {
  border: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 0;
}

.es-head {
  align-items: center;
  border-bottom: 1px solid #eef1f5;
  color: #3a5368;
  display: flex;
  font-size: 0.68rem;
  font-weight: 700;
  justify-content: center;
  min-height: 34px;
  padding: 4px 2px;
  text-align: center;
}

.es-value {
  padding: 4px 2px;
  text-align: center;
}

.es-reading .field-entry {
  min-height: 0;
  padding: 0;
  line-height: 1.2;
  text-align: center;
}

.no-result {
  color: #98a5b3;
  display: inline-block;
  padding: 12px;
}

.empty-state {
  color: #66717d;
  font-style: italic;
  padding: 24px 0;
}

.test-row .design-col.density-value-col {
  background: #fff;
  vertical-align: bottom;
}

.test-row .baseline-col.density-value-col {
  background: #fff;
  vertical-align: bottom;
}

.density-value-stack {
  height: 100%;
  justify-content: center;
}

.density-value-stack .field-entry {
  text-align: center;
}

.test-row .design-col.psd-value-col {
  vertical-align: middle;
}

.psd-value-stack {
  align-items: center;
  height: 100%;
  justify-content: center;
}

.psd-value-stack .field-entry {
  text-align: center;
}

.test-row .design-col.electrical-value-col {
  vertical-align: middle;
}

.electrical-value-col .es-reading .field-value {
  font-size: 1.05rem;
}

/* Same 38px as the FANN 77 label stack (2px padding + 34px title + 2px padding).
   The 4px bottom padding centers the checkbox on the label text. */
.hpht-rheology-value-stack {
  align-items: center;
  justify-content: center;
  min-height: 38px;
  padding: 0 0 4px;
}

.hpht-rheology-checkbox {
  align-items: center;
  display: inline-flex;
  justify-content: center;
  margin: 0;
}

.hpht-rheology-checkbox input {
  accent-color: #0067b8;
  cursor: default;
  height: 16px;
  width: 16px;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/job-details/job-request-details/test-results/test-results.component.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,gBAAA;EACA,6BAAA;AACF;;AAEA;EACE,kBAAA;EACA,sBAAA;AACF;;AAEA;EACE,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,sBAAA;EACA,mBAAA;AACF;AACE;;EAEE,yBAAA;EACA,UAAA;EACA,mBAAA;AACJ;AAEE;EACE,yBAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,iBAAA;AAAJ;;AAIA;EACE,YAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,OAAA;EACA,gBAAA;EACA,UAAA;AADF;;AAIA;EACE,YAAA;EACA,gBAAA;EACA,gBAAA;AADF;;AAIA;EACE,YAAA;EACA,gBAAA;EACA,gBAAA;AADF;;AAIA;EACE,YAAA;EACA,gBAAA;EACA,gBAAA;AADF;;AAIA;EACE,YAAA;EACA,gBAAA;EACA,gBAAA;AADF;;AAIA;EACE,YAAA;EACA,gBAAA;EACA,gBAAA;AADF;;AAIA;EACE,mBAAA;EACA,gBAAA;AADF;;AAIA;EACE,cAAA;EACA,eAAA;AADF;;AAIA;EACE,mBAAA;EACA,WAAA;EACA,gBAAA;EACA,sBAAA;EACA,iBAAA;EACA,yBAAA;AADF;;AAIA;;;EAGE,mBAAA;AADF;;AAIA;EACE,sBAAA;AADF;;AAIA;EACE,gCAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,qBAAA;AADF;;AAIA;EACE,aAAA;EACA,sBAAA;EACA,YAAA;EACA,sBAAA;AADF;;AAIA;;EAEE,cAAA;AADF;;AAIA;EACE,sBAAA;EACA,cAAA;EACA,eAAA;EACA,YAAA;EACA,iBAAA;EACA,gBAAA;EACA,gBAAA;EACA,iBAAA;EACA,uBAAA;EACA,mBAAA;AADF;;AAIA;EACE,cAAA;AADF;;AAIA;EACE,kBAAA;EACA,oBAAA;AADF;;AAIA;EACE,cAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,uBAAA;EACA,mBAAA;AADF;;AAIA;EACE,cAAA;EACA,gBAAA;AADF;;AAIA;EACE,6BAAA;EACA,cAAA;EACA,gBAAA;EACA,YAAA;EACA,qBAAA;AADF;;AAIA;EACE,aAAA;AADF;;AAIA;EACE,6BAAA;EACA,cAAA;EACA,kBAAA;EACA,qBAAA;EACA,iBAAA;AADF;;AAIA;EACE,aAAA;EACA,gCAAA;EACA,cAAA;EACA,iBAAA;EACA,oBAAA;AADF;;AAIA;EACE,mBAAA;EACA,aAAA;EACA,UAAA;EACA,cAAA;AADF;;AAIA;;EAEE,gCAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;AADF;;AAIA;EACE,mBAAA;EACA,cAAA;EACA,aAAA;EACA,kBAAA;EACA,gBAAA;EACA,uBAAA;EACA,gBAAA;AADF;;AAIA;EACE,cAAA;EACA,kBAAA;EACA,gBAAA;AADF;;AAIA;EACE,gBAAA;AADF;;AAIA;EACE,aAAA;EACA,QAAA;EACA,iBAAA;AADF;;AAIA;EACE,mBAAA;EACA,aAAA;EACA,UAAA;EACA,YAAA;EACA,cAAA;AADF;;AAIA;EACE,SAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,UAAA;AADF;;AAIA;EACE,mBAAA;EACA,gCAAA;EACA,cAAA;EACA,aAAA;EACA,kBAAA;EACA,gBAAA;EACA,uBAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;AADF;;AAIA;EACE,gBAAA;EACA,kBAAA;AADF;;AAIA;EACE,aAAA;EACA,UAAA;EACA,gBAAA;EACA,kBAAA;AADF;;AAIA;EACE,cAAA;EACA,qBAAA;EACA,aAAA;AADF;;AAIA;EACE,cAAA;EACA,kBAAA;EACA,eAAA;AADF;;AAIA;EACE,gBAAA;EACA,sBAAA;AADF;;AAIA;EACE,gBAAA;EACA,sBAAA;AADF;;AAIA;EACE,YAAA;EACA,uBAAA;AADF;;AAIA;EACE,kBAAA;AADF;;AAIA;EACE,sBAAA;AADF;;AAIA;EACE,mBAAA;EACA,YAAA;EACA,uBAAA;AADF;;AAIA;EACE,kBAAA;AADF;;AAIA;EACE,sBAAA;AADF;;AAIA;EACE,kBAAA;AADF;;AAIA;mEAAA;AAEA;EACE,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,gBAAA;AADF;;AAIA;EACE,mBAAA;EACA,oBAAA;EACA,uBAAA;EACA,SAAA;AADF;;AAIA;EACE,qBAAA;EACA,eAAA;EACA,YAAA;EACA,WAAA;AADF","sourcesContent":[".test-results-wrapper {\n  width: 100%;\n  overflow-x: auto;\n  border-top: 1px solid #d7dce2;\n}\n\n.test-results-scroll {\n  width: max-content;\n  min-width: max-content;\n}\n\n.test-results-table {\n  border-collapse: collapse;\n  font-size: 0.86rem;\n  width: max-content;\n  min-width: max-content;\n  table-layout: fixed;\n\n  th,\n  td {\n    border: 1px solid #dfe3e8;\n    padding: 0;\n    vertical-align: top;\n  }\n\n  th {\n    background-color: #f6f8fb;\n    color: #274a67;\n    font-weight: 700;\n    text-align: center;\n    white-space: nowrap;\n    padding: 6px 10px;\n  }\n}\n\n.caption-col {\n  width: 720px;\n  min-width: 720px;\n  max-width: 720px;\n  position: sticky;\n  left: 0;\n  background: #fff;\n  z-index: 2;\n}\n\n.test-results-table.is-cutback .caption-col {\n  width: 600px;\n  min-width: 600px;\n  max-width: 600px;\n}\n\n.test-results-table.has-baseline .caption-col {\n  width: 600px;\n  min-width: 600px;\n  max-width: 600px;\n}\n\n.test-results-table.is-cutback.has-baseline .caption-col {\n  width: 480px;\n  min-width: 480px;\n  max-width: 480px;\n}\n\n.baseline-col {\n  width: 120px;\n  min-width: 120px;\n  max-width: 120px;\n}\n\n.design-col {\n  width: 140px;\n  min-width: 140px;\n  max-width: 140px;\n}\n\nth.design-col.wrap-header {\n  white-space: normal;\n  line-height: 1.2;\n}\n\n.group-row td {\n  border-left: 0;\n  border-right: 0;\n}\n\n.group-heading {\n  background: #0067b8;\n  color: #fff;\n  font-weight: 700;\n  letter-spacing: 0.01em;\n  padding: 7px 12px;\n  text-transform: uppercase;\n}\n\n.test-row:nth-child(even) .caption-col,\n.test-row:nth-child(even) .baseline-col,\n.test-row:nth-child(even) .design-col {\n  background: #fcfcfd;\n}\n\n.test-row .design-col {\n  vertical-align: bottom;\n}\n\n.test-name {\n  border-bottom: 1px solid #e2e6eb;\n  color: #1e2f3d;\n  font-size: 0.98rem;\n  font-weight: 700;\n  padding: 8px 12px 7px;\n}\n\n.test-cell-stack {\n  display: flex;\n  flex-direction: column;\n  min-width: 0;\n  vertical-align: bottom;\n}\n\n.labels,\n.values {\n  padding: 2px 0;\n}\n\n.field-entry {\n  box-sizing: border-box;\n  display: block;\n  max-width: 100%;\n  min-width: 0;\n  line-height: 1.35;\n  min-height: 28px;\n  overflow: hidden;\n  padding: 4px 12px;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.labels .field-entry {\n  color: #243746;\n}\n\n.values .field-entry {\n  text-align: center;\n  overflow-wrap: botto;\n}\n\n.values .section-title {\n  color: #1e2f3d;\n  font-weight: 600;\n  overflow: hidden;\n  text-align: center;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.field-value {\n  color: #1e2f3d;\n  font-weight: 600;\n}\n\n.section-title {\n  border-top: 1px solid #e7ebf0;\n  color: #1f2f3a;\n  font-weight: 700;\n  height: 34px;\n  padding: 8px 12px 4px;\n}\n\n.test-cell-stack > .section-title:first-child {\n  border-top: 0;\n}\n\n.cell-meta {\n  border-top: 1px solid #eef1f5;\n  color: #52697d;\n  font-size: 0.75rem;\n  padding: 6px 12px 8px;\n  text-align: right;\n}\n\n.cell-meta-top {\n  border-top: 0;\n  border-bottom: 1px solid #eef1f5;\n  color: #1f2f3a;\n  font-size: 0.8rem;\n  padding: 6px 8px 5px;\n}\n\n.rheology-values-grid {\n  align-items: center;\n  display: grid;\n  gap: 0 2px;\n  padding: 2px 0;\n}\n\n.rheology-value-head,\n.rheology-value-cell {\n  border-bottom: 1px solid #eef1f5;\n  min-height: 28px;\n  padding: 4px 2px;\n  text-align: center;\n}\n\n.rheology-value-head {\n  align-items: center;\n  color: #3a5368;\n  display: flex;\n  font-size: 0.68rem;\n  font-weight: 700;\n  justify-content: center;\n  min-height: 34px;\n}\n\n.rheology-value-cell {\n  color: #1e2f3d;\n  font-size: 0.78rem;\n  font-weight: 400;\n}\n\n.rheology-value-cell.is-bold {\n  font-weight: 700;\n}\n\n.es-matrix {\n  display: grid;\n  gap: 8px;\n  padding: 8px 10px;\n}\n\n.es-matrix.compact {\n  align-items: center;\n  display: grid;\n  gap: 0 2px;\n  height: 100%;\n  padding: 2px 0;\n}\n\n.es-reading {\n  border: 0;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 0;\n}\n\n.es-head {\n  align-items: center;\n  border-bottom: 1px solid #eef1f5;\n  color: #3a5368;\n  display: flex;\n  font-size: 0.68rem;\n  font-weight: 700;\n  justify-content: center;\n  min-height: 34px;\n  padding: 4px 2px;\n  text-align: center;\n}\n\n.es-value {\n  padding: 4px 2px;\n  text-align: center;\n}\n\n.es-reading .field-entry {\n  min-height: 0;\n  padding: 0;\n  line-height: 1.2;\n  text-align: center;\n}\n\n.no-result {\n  color: #98a5b3;\n  display: inline-block;\n  padding: 12px;\n}\n\n.empty-state {\n  color: #66717d;\n  font-style: italic;\n  padding: 24px 0;\n}\n\n.test-row .design-col.density-value-col {\n  background: #fff;\n  vertical-align: bottom;\n}\n\n.test-row .baseline-col.density-value-col {\n  background: #fff;\n  vertical-align: bottom;\n}\n\n.density-value-stack {\n  height: 100%;\n  justify-content: center;\n}\n\n.density-value-stack .field-entry {\n  text-align: center;\n}\n\n.test-row .design-col.psd-value-col {\n  vertical-align: middle;\n}\n\n.psd-value-stack {\n  align-items: center;\n  height: 100%;\n  justify-content: center;\n}\n\n.psd-value-stack .field-entry {\n  text-align: center;\n}\n\n.test-row .design-col.electrical-value-col {\n  vertical-align: middle;\n}\n\n.electrical-value-col .es-reading .field-value {\n  font-size: 1.05rem;\n}\n\n/* Same 38px as the FANN 77 label stack (2px padding + 34px title + 2px padding).\n   The 4px bottom padding centers the checkbox on the label text. */\n.hpht-rheology-value-stack {\n  align-items: center;\n  justify-content: center;\n  min-height: 38px;\n  padding: 0 0 4px;\n}\n\n.hpht-rheology-checkbox {\n  align-items: center;\n  display: inline-flex;\n  justify-content: center;\n  margin: 0;\n}\n\n.hpht-rheology-checkbox input {\n  accent-color: #0067b8;\n  cursor: default;\n  height: 16px;\n  width: 16px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
